// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import Vant from 'vant';
import chart from 'chart.js';
import 'vant/lib/index.css';
import KS_Compoents from './ks-components'
Vue.config.productionTip = false



Vue.use(Vant)
Vue.use(KS_Compoents)
/* eslint-disable no-new */
const APP = new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})
export default APP


// WEBPACK FOOTER //
// ./src/main.js